import { MaybeRefOrGetter, toValue, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { whenAuthenticatedAnd } from '@/utils/query-utils'
import {
    fetchGeneratorVisualInspectionList,
    generatorVisualInspectionsQueryKey,
} from '@/api/queries/generators/generatorVisualInspectionsQuery'

export const useGeneratorVisualInspectionsQuery = (generatorId: MaybeRefOrGetter<string | undefined>) => {
    return useQuery({
        queryKey: computed(() => {
            const id = toValue(generatorId)
            return id
                ? generatorVisualInspectionsQueryKey(id)
                : (['generators', 'visual-inspection', '__none__'] as const)
        }),
        queryFn: async ({ signal }) => {
            const id = toValue(generatorId)
            if (!id) {
                return undefined
            }
            return fetchGeneratorVisualInspectionList(id, signal)
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(generatorId))),
    })
}
